import { render } from "./V1ScreenScaffold.vue?vue&type=template&id=6c4d632e&scoped=true&ts=true"
import script from "./V1ScreenScaffold.vue?vue&type=script&lang=ts"
export * from "./V1ScreenScaffold.vue?vue&type=script&lang=ts"

import "./V1ScreenScaffold.vue?vue&type=style&index=0&id=6c4d632e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4d632e"]])

export default __exports__